import React from 'react';
import selectedHotelIcon from '../images/hotel-selected.png';
import restaurantIcon from '../images/restaurant-icon.png';
import attractionIcon from '../images/attraction-icon.png';
import {trim_name} from '../utils.js';

const SelectedMarker = (props) => {
  var icon;
  switch (props.type) {
    case "hotel":
      icon= selectedHotelIcon;
      break;
    case "restaurant":
      icon = restaurantIcon;
      break;
    case "attraction":
      icon = attractionIcon;
      break;
    default:
      console.log("no icon found")
    }

  var short_name = trim_name(props.name, 3)

  return (
    <div><img src={ icon } alt='selected'/><b>{short_name}</b></div>
  )
}

export default SelectedMarker
